import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtonipanicab() {



    const cardData = {




keyword: "Belgaum to Nipani Cab",

headingDescription: "Belgaum Taxi Service provides reliable and comfortable Belgaum to Nipani cab services for business travel, family visits, daily transportation, shopping trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Nipani, we offer safe and convenient travel with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel needs. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth journey. Belgaum Taxi Service connects passengers between Belgaum and Nipani with affordable cab solutions for professionals, families, and travelers requiring comfortable short-distance and intercity transportation.",

topPlaces: [
  {
    title: "Nipani",
    description: "Nipani is an important town on the Karnataka-Maharashtra border, known for trade, agriculture, markets, and commercial activities. It is a frequently traveled destination from Belgaum."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a major city near Nipani known for Mahalaxmi Temple, traditional markets, cultural heritage, and business activities, making it a popular travel destination."
  },
  {
    title: "Panhala Fort",
    description: "Panhala Fort is a historic hill fort near Kolhapur known for Maratha history, scenic views, and pleasant surroundings, attracting tourists throughout the year."
  },
  {
    title: "Goa",
    description: "Goa is a famous holiday destination known for beaches, resorts, churches, and sightseeing attractions. Travelers prefer private cabs for comfortable trips from Belgaum."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra. Cab services are preferred for corporate travel, family visits, and long-distance journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital with major business areas, airports, and tourist attractions. Comfortable cabs provide convenient connectivity for interstate travel."
  },
  {
    title: "Belagavi Airport",
    description: "Belagavi Airport provides air connectivity for nearby cities and towns. Cab services offer convenient airport pickup and drop facilities for Nipani travelers."
  },
  {
    title: "Gokak Falls",
    description: "Gokak Falls is a beautiful natural attraction near Belgaum known for waterfalls, scenic landscapes, and peaceful surroundings, making it ideal for short trips."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a popular adventure destination known for wildlife, forests, river rafting, and nature activities, attracting families and groups."
  },
  {
    title: "Hubballi",
    description: "Hubballi is an important commercial city in Karnataka known for business, education, and healthcare facilities. It is a common travel destination from North Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Nipani Cab",
    "description": "Book Belgaum to Nipani Cab for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for local travel, business trips, family journeys, and outstation requirements."
  },
  {
    "name": "Belgaum to Nipani Taxi",
    "description": "Hire Belgaum to Nipani Taxi for convenient and affordable transportation with experienced drivers and clean vehicles. Enjoy smooth travel between Belgaum and Nipani with flexible one way and round trip booking options."
  },
  {
    "name": "Belgaum to Nipani Cab Service",
    "description": "Choose Belgaum to Nipani Cab Service for dependable intercity travel with doorstep pickup, transparent pricing, and professional drivers. Our cab services are ideal for personal trips, corporate travel, family visits, and regular transportation needs."
  },
  {
    "name": "Belgaum to Nipani Taxi Service",
    "description": "Book Belgaum to Nipani Taxi Service for comfortable journeys with reliable chauffeurs and premium AC vehicles. Get hassle-free transportation with affordable fares and flexible travel solutions."
  },
  {
    "name": "Belgaum to Nipani One Way Cab",
    "description": "Reserve Belgaum to Nipani One Way Cab for economical point-to-point travel without return charges. Enjoy comfortable rides, fixed pricing, and professional chauffeur services for your journey."
  },
  {
    "name": "Belgaum to Nipani One Way Taxi",
    "description": "Choose Belgaum to Nipani One Way Taxi for budget-friendly single destination travel. Get clean vehicles, experienced drivers, and convenient pickup facilities for a smooth journey."
  },
  {
    "name": "Belgaum to Nipani Cab Booking",
    "description": "Complete Belgaum to Nipani Cab Booking with easy online reservations and quick confirmation. Select your preferred vehicle category including Sedan, Ertiga, Innova Crysta, and SUV for comfortable travel."
  },
  {
    "name": "Belgaum to Nipani Taxi Booking",
    "description": "Book Belgaum to Nipani Taxi Booking services for reliable and comfortable transportation. Enjoy professional drivers, sanitized cars, affordable rates, and flexible travel plans."
  },
  {
    "name": "Belgaum to Nipani Car Rental",
    "description": "Choose Belgaum to Nipani Car Rental with driver for convenient travel solutions. Hire comfortable vehicles for family trips, business visits, sightseeing, and outstation journeys."
  },
  {
    "name": "Belgaum to Nipani Outstation Cab",
    "description": "Travel with Belgaum to Nipani Outstation Cab services offering safe and comfortable long-distance transportation. Get experienced chauffeurs, well-maintained vehicles, and flexible one way or round trip options."
  },
  {
    "name": "Belgaum to Nipani Innova Crysta Cab",
    "description": "Book Belgaum to Nipani Innova Crysta Cab for premium and spacious travel. Enjoy luxury seating, large luggage capacity, and comfortable rides suitable for families, groups, and corporate passengers."
  },
  {
    "name": "Belgaum to Nipani Ertiga Cab",
    "description": "Hire Belgaum to Nipani Ertiga Cab for affordable 6 to 7 seater travel. The spacious Ertiga is perfect for family trips, group journeys, and comfortable outstation transportation."
  },
  {
    "name": "Belgaum to Nipani Sedan Cab",
    "description": "Book Belgaum to Nipani Sedan Cab for economical and comfortable travel. Enjoy AC sedan vehicles with professional chauffeurs suitable for business travel, personal trips, and small groups."
  },
  {
    "name": "Belgaum to Nipani Round Trip Cab",
    "description": "Reserve Belgaum to Nipani Round Trip Cab for convenient return journeys with affordable packages. Ideal for family visits, sightseeing, business travel, and planned trips between both locations."
  },
  {
    "name": "Belgaum to Nipani Private Taxi",
    "description": "Choose Belgaum to Nipani Private Taxi for personalized travel with dedicated vehicles and professional drivers. Experience privacy, comfort, and flexible schedules throughout your journey."
  },
  {
    "name": "Cheap Belgaum to Nipani Cab",
    "description": "Find Cheap Belgaum to Nipani Cab services offering affordable fares with quality vehicles and reliable drivers. Enjoy safe transportation without compromising comfort and service quality."
  },
  {
    "name": "Best Belgaum to Nipani Cab Service",
    "description": "Select the Best Belgaum to Nipani Cab Service with experienced chauffeurs, premium vehicles, and competitive pricing. Get reliable travel solutions for families, businesses, and individual passengers."
  },
  {
    "name": "Online Belgaum to Nipani Cab Booking",
    "description": "Book Online Belgaum to Nipani Cab Booking services with easy reservations, instant confirmation, and multiple vehicle options. Plan your journey conveniently with professional cab operators."
  },
  {
    "name": "Belgaum to Nipani Taxi Fare",
    "description": "Get affordable Belgaum to Nipani Taxi Fare with transparent pricing and flexible packages. Choose suitable cab options based on passengers, luggage, and travel requirements."
  },
  {
    "name": "Belgaum to Nipani Car Hire",
    "description": "Hire Belgaum to Nipani Car Hire services with comfortable vehicles and professional drivers. Suitable for family travel, corporate visits, sightseeing tours, and personal transportation."
  },
  {
    "name": "Belgaum to Nipani Cab Price",
    "description": "Check Belgaum to Nipani Cab Price and choose affordable travel options. Get reliable AC cabs with flexible booking choices for one way, round trip, and customized journeys."
  },
  {
    "name": "Belgaum to Nipani Family Cab",
    "description": "Book Belgaum to Nipani Family Cab for safe and comfortable family travel. Enjoy spacious vehicles, experienced drivers, and convenient transportation for vacations and personal trips."
  },
  {
    "name": "Belgaum to Nipani Corporate Taxi",
    "description": "Choose Belgaum to Nipani Corporate Taxi for professional business travel solutions. Get punctual service, executive vehicles, and trained chauffeurs for meetings, office travel, and corporate requirements."
  },
  {
    "name": "Belgaum to Nipani Airport Transfer",
    "description": "Book Belgaum to Nipani Airport Transfer service for timely airport pickup and drop facilities. Travel comfortably with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Nipani Cab Fare",
    "description": "Get details about Belgaum to Nipani Cab Fare with affordable pricing and multiple vehicle categories. Select Sedan, Ertiga, Innova Crysta, or SUV according to your travel needs."
  },
  {
    "name": "Belgaum to Nipani Taxi Near Me",
    "description": "Find Belgaum to Nipani Taxi Near Me for quick and reliable taxi availability. Book comfortable cabs with professional drivers for safe and convenient travel."
  },
  {
    "name": "Belgaum to Nipani Outstation Taxi",
    "description": "Hire Belgaum to Nipani Outstation Taxi for comfortable intercity travel with clean AC vehicles and experienced chauffeurs. Enjoy reliable transportation for family, business, and personal journeys."
  }
],
"tableData": [
  ["Belgaum to Nipani Cab", "Belgaum to Nipani Taxi"],
  ["Belgaum to Nipani Cab Service", "Belgaum to Nipani Taxi Service"],
  ["Belgaum to Nipani One Way Cab", "Belgaum to Nipani One Way Taxi"],
  ["Belgaum to Nipani Cab Booking", "Belgaum to Nipani Taxi Booking"],
  ["Belgaum to Nipani Car Rental", "Belgaum to Nipani Outstation Cab"],
  ["Belgaum to Nipani Innova Crysta Cab", "Belgaum to Nipani Ertiga Cab"],
  ["Belgaum to Nipani Sedan Cab", "Belgaum to Nipani Round Trip Cab"],
  ["Belgaum to Nipani Private Taxi", "Cheap Belgaum to Nipani Cab"],
  ["Best Belgaum to Nipani Cab Service", "Online Belgaum to Nipani Cab Booking"],
  ["Belgaum to Nipani Taxi Fare", "Belgaum to Nipani Car Hire"],
  ["Belgaum to Nipani Cab Price", "Belgaum to Nipani Family Cab"],
  ["Belgaum to Nipani Corporate Taxi", "Belgaum to Nipani Airport Transfer"],
  ["Belgaum to Nipani Cab Fare", "Belgaum to Nipani Taxi Near Me"],
  ["Belgaum to Nipani Outstation Taxi", ""]
],





whychoose: [
  {
    WhyChooseheading: "Convenient Belgaum to Nipani Cab Service",
    WhyChoosedescription: "Travel easily between Belgaum and Nipani with a trusted taxi option offering comfortable cars, experienced drivers, and flexible travel arrangements for every journey."
  },
  {
    WhyChooseheading: "Quick Local Route Connectivity",
    WhyChoosedescription: "Our Belgaum to Nipani cabs provide smooth point-to-point travel with pickup from your preferred location and direct drop at your destination."
  },
  {
    WhyChooseheading: "Vehicles Available for All Requirements",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV vehicles based on your passenger count and travel comfort."
  },
  {
    WhyChooseheading: "Suitable for Daily & Personal Travel",
    WhyChoosedescription: "Whether it is a business visit, family trip, shopping purpose, medical travel, or personal work, our taxis offer a convenient travel solution."
  },
  {
    WhyChooseheading: "Professional Drivers & Smooth Rides",
    WhyChoosedescription: "Experienced chauffeurs ensure timely service, safe driving, and a comfortable ride with proper knowledge of the Belgaum to Nipani route."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Cabs",
    WhyChoosedescription: "Select a one-way taxi for direct travel or choose a return trip package according to your schedule and convenience."
  },
  {
    WhyChooseheading: "Affordable Travel Options",
    WhyChoosedescription: "Get suitable cab choices with transparent pricing and travel packages designed according to your vehicle and journey requirements."
  },
  {
    WhyChooseheading: "Easy Taxi Booking Support",
    WhyChoosedescription: "Receive assistance for cab availability, vehicle selection, fare details, and booking confirmation for your Belgaum to Nipani journey."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Nipani Cab Service?",
    answer: "Yes, we offer Belgaum to Nipani taxi services with comfortable vehicles and professional drivers for local and outstation travel."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Nipani?",
    answer: "Yes, one-way taxi service is available for passengers who require direct transportation between Belgaum and Nipani."
  },
  {
    question: "Which vehicles are available for Belgaum to Nipani travel?",
    answer: "You can choose Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs based on your requirements."
  },
  {
    question: "Is Belgaum to Nipani cab service suitable for family travel?",
    answer: "Yes, comfortable vehicles with spacious seating are available for families and small groups."
  },
  {
    question: "Can I book a return taxi from Nipani to Belgaum?",
    answer: "Yes, return trip cabs are available with flexible timing options based on your travel plan."
  },
  {
    question: "Do you provide pickup from Belgaum Airport or Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi for Belgaum to Nipani?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Additional charges such as toll, parking, and other applicable fees depend on the selected travel package and are explained during booking."
  },
  {
    question: "Is Belgaum to Nipani taxi available anytime?",
    answer: "Yes, taxi booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Nipani Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to get fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Patil",
    feedback: "The Belgaum to Nipani cab service was smooth and convenient. The driver was punctual, and the vehicle was clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback: "A great travel experience with professional service. The cab arrived on time, and the journey was comfortable from start to finish.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Nipani Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-nipani-cab.webp",
  "description":
    "Book Belgaum to Nipani Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Nipani with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, business trips, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-nipani-cab"
  }
};



    return (
        <div>




<Helmet>
  <title>Belgaum to Nipani Cab | Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Nipani Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Nipani with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable local and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Nipani Cab, Belgaum to Nipani Taxi, Belgaum to Nipani Cab Service, Belgaum to Nipani Taxi Service, Belgaum to Nipani One Way Cab, Belgaum to Nipani One Way Taxi, Belgaum to Nipani Cab Booking, Belgaum to Nipani Car Rental, Belgaum to Nipani Outstation Cab, Belgaum to Nipani Taxi Fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtonipanicab;